import { nonEmptyTrimmedStringFromUnknown } from "../protocol/shared.js";
                                                
import { signalEnvelopeSchema } from "../protocol/envelope.js";
import * as z$1 from "zod/v4";
//#region src/schemas/http/space-updates.ts
const DECIMAL_INTEGER_REGEX = /^\d+$/u;
const updatesLimitSchema = z$1.preprocess((value) => {
	if (value === void 0 || value === null || value === "") return 20;
	if (typeof value === "number") return value;
	const normalized = String(value).trim();
	if (normalized.length === 0) return 20;
	if (!DECIMAL_INTEGER_REGEX.test(normalized)) return NaN;
	return Number.parseInt(normalized, 10);
}, z$1.number().int().min(1).max(200)).default(20);
const getSpaceUpdatesInputSchema = z$1.strictObject({
	spaceId: nonEmptyTrimmedStringFromUnknown,
	afterSignalId: nonEmptyTrimmedStringFromUnknown,
	limit: updatesLimitSchema
});
const getSpaceUpdatesResponseSchema = z$1.strictObject({ signals: z$1.array(signalEnvelopeSchema) });
//#endregion
export { getSpaceUpdatesInputSchema, getSpaceUpdatesResponseSchema };

//# sourceMappingURL=space-updates.js.map